
import { PatientStatus } from "@/types/patient.types";

export const usePatientStatusValidation = () => {
  const validateStatus = (status: string): status is PatientStatus => {
    const validStatuses: PatientStatus[] = ['pending', 'approved', 'rejected'];
    return validStatuses.includes(status as PatientStatus);
  };

  return { validateStatus };
};
